import { emptySplitApi } from "./InjectionEndpoint";

const privacyApi = emptySplitApi.injectEndpoints({
    
    endpoints: (build: any) => ({
        
        getMeStatus: build.query({
            query: () => `/api/account/me/status`,
            providesTags: ['status']
        }),

        acceptPrivacy: build.mutation({
            query: ({aziendaId, ...rest}: {aziendaId: number, rest:any}) => ({
                url: `/api/azienda/${aziendaId}/documento-aziendale/presa-visione`,
                method: 'POST',
                body: rest
            }),
            invalidatesTags: ['status']
        }),

    }),
});

export const {
useGetMeStatusQuery,
useAcceptPrivacyMutation
} = privacyApi;